import Toastify from "toastify-js";

function showToast({ type = "info", message = "", innerHtml = null }) {
  const spanWrapper = document.createElement("span");
  spanWrapper.classList.add("toast-text");
  if (innerHtml) {
    spanWrapper.innerHTML = innerHtml;
  } else {
    spanWrapper.textContent = message;
  }

  const className = `toast toast--${type}`;

  Toastify({
    node: spanWrapper,
    duration: 4000,
    close: true,
    gravity: "bottom",
    position: "center",
    className: className,
    offset: {
      x: "50%",
      y: "50px",
    },
    stopOnFocus: true,
  }).showToast();
}

export const toast = {
  success(message, innerHtml = null) {
    showToast({ type: "success", message, innerHtml });
  },
  error(message, innerHtml = null) {
    showToast({ type: "error", message, innerHtml });
  },
  info(message, innerHtml = null) {
    showToast({ type: "info", message, innerHtml });
  },
};
